import map from "./map";
import Evented from "./Evented";
import rscope from "./rootScope";
import store from "./store";
import broadcast from "./broadcast";
import plugins from "./plugins";

// define("singleclick", ["map", "Evented", "rootScope", "store", "broadcast", "plugins"], function(map, Evented, rscope, store, broadcast, plugins) { //e, t, n, i, s
const isMobile = rscope.isMobile;
export default Evented.instance({
    ident: "singleclick",
    hpJustClosed: false,
    // priorities: ["detail", "sounding", "distance", "rplanner", "cap-alerts"],
    priorities: [],
    _init: function() {
        Evented._init.call(this);
        map.on("singleclick", this.opener, this);
        if ( isMobile )
            store.on("hpShown", this.hpShown, this)
    },
    hpShown: function(e) {
        var t = this;
        e || (this.hpJustClosed = true,
            setTimeout(function() {
                return t.hpJustClosed = false
            }, 1e3))
    },
    parseEvent: function(event) {
        return {
            x: event.containerPoint.x,
            y: event.containerPoint.y,
            lat: event.latlng.lat,
            lon: event.latlng.lng,
            source: "singleclick"
        }
    },
    opener: function(event) {
        if (! this.hpJustClosed) {
            var target = event.originalEvent && event.originalEvent.target
                , dataset = target && target.dataset;
            if (dataset && dataset.poi)
                this.emit("poi-" + dataset.poi, target, dataset);
            else {
                var point = this.parseEvent(event);
                for (var i = 0; i < this.priorities.length; i++) {

                    var namePlugin = this.priorities[i];

                    if (plugins[namePlugin].isOpen)
                        return void this.emit(namePlugin, point)
                }
                // this.emit("click", point);
                broadcast.emit("rqstOpen", "picker", point)
            }
        }
    }
})
